import { Tooltip as MuiTooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

type TooltipProps = {
    message: string | React.ReactNode;
    // What it opens on - an info icon when nothing is given.
    children?: React.ReactElement;
    placement?: 'top' | 'bottom' | 'left' | 'right';
    maxWidth?: number;
}

const Tooltip: React.FC<TooltipProps> = ({ message, children, placement = 'top', maxWidth = 300 }) => {
    return (
        <MuiTooltip
            title={message}
            arrow
            placement={placement}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: 'var(--color-page-background)',
                        color: 'var(--color-default-text)',
                        fontSize: 13,
                        padding: '8px 16px',
                        maxWidth,
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                        '& .MuiTooltip-arrow': {
                            color: 'var(--color-page-background)',
                        }
                    }
                }
            }}
        >
            {children ?? (
                <span
                    style={{
                        marginLeft: 8,
                        color: 'var(--color-primary)',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 16,
                        height: 16,
                        flexShrink: 0
                    }}
                >
                    <InfoOutlinedIcon sx={{ color: 'var(--color-primary)', fontSize: 16 }} />
                </span>
            )}
        </MuiTooltip>
    );
};

export default Tooltip;
